import { useDownloadFiles } from './useDownloadFiles'
import { useUploadFiles } from './useUploadFiles'

/** @deprecated Use `useUploadFiles` or `useDownloadFiles`, whichever the caller needs. */
export const useDocuments = () => ({ ...useUploadFiles(), ...useDownloadFiles() })
